import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EdpWidgetConsumptionOmieComponent } from "./edp-widget-consumption-omie.component";
import { TranslateModule } from "@ngx-translate/core";
import { EdpFilterPickerModule } from "@edp-components/edp-filter-picker/edp-filter-picker.module";

@NgModule({
    declarations: [EdpWidgetConsumptionOmieComponent],
    imports: [CommonModule, TranslateModule, EdpFilterPickerModule],
    exports: [EdpWidgetConsumptionOmieComponent],
})
export class EdpWidgetConsumptionOmieModule {}
